import CreatingUser from './CreatingUser';
import ActionsOnGroups from './ActionsOnGroups';
import UsersList from './UsersList';
import BitdefenderLogo from '../../../base_components/BitdefenderLogo';
import {USER_TYPES} from '../../../utils/utils';

import styles from '../../../styles/base_components/Page.module.scss';

function Users(props) {
  return (
    <div className={styles.page}>
      <CreatingUser className={styles.group} types={USER_TYPES}/>
      <ActionsOnGroups className={styles.group}/>
      <UsersList className={styles.group}/>

      <BitdefenderLogo/>
    </div>
  );
}

export default Users;